import { useState } from 'react'
import { Grid, TextField, Typography } from "@mui/material";
import { Autocomplete } from "@mui/material";
import ButtonComponent from "../shared/button/button.component";
import { appNote, buttonLabels, ToasterTexts } from "../shared/constants";
import { UtilityService } from '../../services/UtilityService';
import { TimeZoneModel } from '../../models/settings-model';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import CustomSwitch from '../shared/switch.component';
import SettingsHeader from './settingsHeader.component';
import { AppRoutes } from '../routes/route.path';
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { ChannelUserService } from '../../services/ChannelUserService';

let timeZonesTypes = UtilityService.getTimeZones();

interface Props { }

const TimeZone = (props: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const CurrentUser = ChannelUserService.getCurrentUserFromLocalStorage();

    const [timeZone, setTimeZone] = useState<string>(CurrentUser.Timezone.SelectedTimeZone)
    const [isChecked, setIsChecked] = useState<boolean>(CurrentUser.Timezone.IsDefaultTimezone)
    const [isLoading, setIsLoading] = useState<boolean>()


    const formSubmit = () => {
        let data = {
            "selected_timezone": timeZone,
            "is_default_timezone": isChecked
        }
        setIsLoading(true)
        ChannelUserService.updateUserTimeZone(CurrentUser.ID, data).then(() => {
            ChannelUserService.getCurrentUser(CurrentUser.Email).then((res) => {
                setIsLoading(false)
                navigate(AppRoutes.SETTINGS)
            })
            setToast(ToasterTexts.TIME_ZONE_MESSAGE, ToasterType.SUCCESS)
        }).catch(() => {
            setIsLoading(false)
        })
    }

    const handleSwitch = (change: boolean) => {
        setIsChecked(change)
    }

    const handleOnchange = (event: any, value: any | null) => {
        if (value) {
            setTimeZone(value.Name)
        }
    }

    return (
        <>
            <div className="w-p-96 d-flex flex-direction mx-auto br-3 settings-border">
                <div className='w-p-100 min-h-6 d-flex justify-between align-center'>
                    <div className="h5-medium pl-2"> Set your relevant Time Zone</div>
                    <div className="h5-medium pr-2 d-flex align-center">
                        <span className='pr-2'>Set Timezone automatically</span>
                        <CustomSwitch
                            checked={isChecked}
                            onChange={(checked: boolean) => handleSwitch(checked)}
                        />
                    </div>
                </div>
                <div className='px-2 min-h-6 d-flex justify-between align-center'>
                    <Autocomplete
                        size="small"
                        className={`${isChecked ? "w-fill bg-color-secondary-main" : "w-fill"}`}
                        classes={{ input: ` color-text-field-font `, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow pl-2' }}
                        options={timeZonesTypes}
                        disabled={isChecked}
                        disableClearable
                        getOptionLabel={(option: TimeZoneModel) => option && option.OffsetLabel && option.Name ? `(${option.OffsetLabel}) ${option.Name}` : ""}
                        onChange={handleOnchange}
                        value={isChecked ? UtilityService.getDefaultTimeZone() : timeZonesTypes.find(x => x.Name === timeZone)}
                        // renderOption={(defaultprops, option: any) => (
                        //     <li {...defaultprops} data-name={option.Name} className={`c-pointercolor-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                        //         ({option.OffsetLabel}) {option.Name}
                        //     </li>
                        // )}
                        defaultValue={timeZone}
                        onOpen={() => {
                            setTimeout(() => {
                                const element = document.querySelector(
                                    `[data-name="${timeZone}"]`
                                );
                                element?.scrollIntoView({ behavior: "auto", block: "center", inline: "center" })
                            }, 0);
                        }}
                        renderInput={(params) => <TextField {...params} name="Time Zone" variant="filled" label="Time Zone" placeholder="Time Zone" />}
                    />
                </div>
                  <div className='min-h-6 d-flex justify-flex-end align-center mt-1 pr-2 ml-auto'>
                    <ButtonComponent
                        Variant="primary-btn-small"
                        ClassName={`c-pointer w-space`}
                        OnClick={formSubmit}
                        ButtonLabel={buttonLabels.SAVE}
                        Loading={isLoading}
                    />
                </div>
            </div>
        </>
        //     {/* <Grid container className="p-3">
        //         <Grid item className="t-align-left d-flex  py-1 my-auto">
        //             <Typography className="h3-semibold t-align-left">
        //                 {appNote.SET_TIME_ZONE}
        //             </Typography>
        //         </Grid>
        //         <Grid item className="b-none my-auto ml-auto" >
        //             <CustomSwitch
        //                 checked={isChecked}
        //                 onChange={(checked: boolean) => handleSwitch(checked)}
        //             />
        //         </Grid>
        //     </Grid>
        //     <form onSubmit={formSubmit}>
        //         {<Grid container className="px-3 pb-3">
        //             <Autocomplete
        //                 size="small"
        //                 className={`${isChecked ? "w-fill bg-color-secondary-main" : "w-fill"}`}
        //                 classes={{ input: ` color-text-field-font `, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
        //                 options={timeZonesTypes}
        //                 disabled={isChecked}
        //                 disableClearable
        //                 getOptionLabel={(option: TimeZoneModel) => option && option.OffsetLabel && option.Name ? `(${option.OffsetLabel}) ${option.Name}` : ""}
        //                 onChange={handleOnchange}
        //                 value={isChecked ? UtilityService.getDefaultTimeZone() : timeZonesTypes.find(x => x.Name === timeZone)}
        //                 renderOption={(defaultprops, option: any) => (
        //                     <li {...defaultprops} data-name={option.Name} className={`c-pointercolor-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
        //                         ({option.OffsetLabel}) {option.Name}
        //                     </li>
        //                 )}
        //                 defaultValue={timeZone}
        //                 onOpen={() => {
        //                     setTimeout(() => {
        //                         const element = document.querySelector(
        //                             `[data-name="${timeZone}"]`
        //                         );
        //                         element?.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });

        //                     }, 0);
        //                 }}
        //                 renderInput={(params) => <TextField {...params} name="Time Zone" variant="outlined" label="Time Zone" placeholder="Time Zone" />}
        //             />
        //             {<Grid item xs={12} className="d-flex mt-2 justify-flex-end" >
        //                 <ButtonComponent
        //                     Variant="primary-btn-small"
        //                     ClassName={`c-pointer w-space mr-1`}
        //                     Type={"submit"}
        //                     ButtonLabel={buttonLabels.SAVE}
        //                     Loading={isLoading}
        //                 />
        //                 <ButtonComponent
        //                     Variant="secondary-btn-small"
        //                     ClassName={`c-pointer`}
        //                     OnClick={() => navigate(AppRoutes.SETTINGS)}
        //                     ButtonLabel={buttonLabels.CANCEL}
        //                 />
        //             </Grid>}
        //         </Grid>}
        //     </form>
        // </div> */}
    )
}

export default TimeZone;